// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2hwz7","list":"styles_list__3A_2X"};